import React from 'react';
import { Box, Container, Typography, List, ListItem, ListItemIcon, ListItemText, Paper, Divider, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SchoolIcon from '@mui/icons-material/School';
import PublishIcon from '@mui/icons-material/Publish';
import ComputerIcon from '@mui/icons-material/Computer';
import Can from "../components/Can";
import SubbedLabPage from "./subbedLab/SubbedLabPage";
import NewsCarousel from "./NewsCarousel";

function Home(props) {
    const navigate = useNavigate();
    var myHome;

    if (!props.apiAuthResponse) {
        myHome = (
            <Box sx={{ width: '100%', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f4f4f4' }}>
                <Container maxWidth="sm">
                    <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
                        <Typography variant="h3" component="h1" sx={{ fontWeight: 'bold', mb: 2, color: '#a71e3b' }}>
                            🔐 LIBaaS
                        </Typography>
                        <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
                            Per accedere al portale occorre autenticarsi
                        </Typography>
                        <Button
                            variant="contained"
                            href={process.env.REACT_APP_URL_AUTH_LOGIN}
                            sx={{
                                bgcolor: '#a71e3b',
                                '&:hover': { bgcolor: '#8a1830' },
                                fontWeight: 600,
                                px: 4,
                                py: 1
                            }}
                        >
                            Login
                        </Button>
                    </Paper>
                </Container>
            </Box>
        )
    } else {

        var itemLabRequest = <Can
            role={props.apiAuthGroups}
            perform="labRequest-page:visit"
            yes={() => (
                <ListItem
                    onClick={() => navigate('/ReqLabV2')}
                    sx={{ '&:hover': { bgcolor: '#f5f5f5', cursor: 'pointer' } }}
                >
                    <ListItemIcon><SchoolIcon sx={{ color: '#a71e3b' }} /></ListItemIcon>
                    <ListItemText
                        primary="Richiesta Laboratori"
                        secondary="Richiedi nuovi laboratori virtuali"
                    />
                </ListItem>
            )}
            no={() => null}
        />

        var itemLabPub = <Can
            role={props.apiAuthGroups}
            perform="labRequest-page:visit"
            yes={() => (
                <ListItem
                    onClick={() => navigate('/PubLab')}
                    sx={{ '&:hover': { bgcolor: '#f5f5f5', cursor: 'pointer' } }}
                >
                    <ListItemIcon><PublishIcon sx={{ color: '#a71e3b' }} /></ListItemIcon>
                    <ListItemText
                        primary="Gestione Laboratori"
                        secondary="Gestisci i tuoi laboratori virtuali"
                    />
                </ListItem>
            )}
            no={() => null}
        />


        var itemLabPredefiniti = <Can
            role={props.apiAuthGroups}
            perform="labPredefiniti-page:visit"
            yes={() => (
                <ListItem
                    onClick={() => navigate('/labPredefiniti')}
                    sx={{ '&:hover': { bgcolor: '#f5f5f5', cursor: 'pointer' } }}
                >
                    <ListItemIcon><ComputerIcon sx={{ color: '#a71e3b' }} /></ListItemIcon>
                    <ListItemText
                        primary="Laboratori Predefiniti"
                        secondary="Iscriviti ai laboratori virtuali predefiniti e gestisci le tue applicazioni"
                    />
                </ListItem>
            )}
            no={() => null}
        />

        var itemLabSubbed = <Can
            role={props.apiAuthGroups}
            perform="labSubbed-page:visit"
            yes={() => (
                <SubbedLabPage
                    apiAuthResponse={props.apiAuthResponse}
                    apiAuthName={props.apiAuthName}
                    apiAuthSurname={props.apiAuthSurname}
                    apiAuthGroups={props.apiAuthGroups}
                />
            )}
            no={() => null}
        />


        if (!props.apiAuthName)
            myHome = null;
        else {
            var myStuMatricola = null;
            if (props.stuMatricola) {
                myStuMatricola = (
                    <Typography variant="body2" sx={{ color: '#666', mb: 1 }}>
                        <strong>Matricola:</strong> {props.stuMatricola}
                    </Typography>
                );
            }

            myHome = (
                <Box sx={{ width: '100%', minHeight: '100vh', bgcolor: '#f4f4f4', py: 4 }}>
                    <Container maxWidth="lg">
                        {/* Header Section */}
                        <Box sx={{ mb: 4 }}>
                            <Typography variant="h3" component="h1" sx={{ fontWeight: 'bold', mb: 0.5, color: '#a71e3b' }}>
                                Benvenuto, {props.apiAuthName} {props.apiAuthSurname}
                            </Typography>
                            {myStuMatricola}
                        </Box>

                        {/* News Carousel Section */}
                        <NewsCarousel />

                        {/* Servizi Section */}
                        <Paper elevation={0} sx={{ mb: 4, border: '1px solid #e0e0e0' }}>
                            <Box sx={{ p: 3 }}>
                                <Typography variant="h5" component="h2" sx={{ fontWeight: 'bold', mb: 2, color: '#333' }}>
                                    🎯 Servizi Disponibili
                                </Typography>
                                <Divider sx={{ mb: 2 }} />
                                <List sx={{ p: 0 }}>
                                    {itemLabRequest}
                                    {itemLabPub}
                                    {itemLabPredefiniti}
                                </List>
                            </Box>
                        </Paper>

                        {/* Laboratori Iscritti */}
                        {itemLabSubbed}
                    </Container>
                </Box>
            )
        }
    }

    return myHome;
}

export default Home;